import React from "react";
import { statusColors, statusLabel } from "../lib/fleet";

export function StatusBadge({ status, testID }) {
  const c = statusColors(status);
  return (
    <span
      data-testid={testID || `status-badge-${status}`}
      style={{
        display: "inline-flex", alignItems: "center", gap: 6,
        padding: "4px 10px", borderRadius: 999,
        background: c.bg, color: c.text,
        fontSize: 11, fontWeight: 800, letterSpacing: 0.2,
      }}
    >
      <span style={{ width: 6, height: 6, borderRadius: 3, background: c.solid }} />
      {statusLabel(status)}
    </span>
  );
}
